export default __webpack_public_path__ + "static/media/tiktok.72eec6d7.png";